module.exports = __webpack_public_path__ + "static/img/qcode.623f0743.png";